// extracted by mini-css-extract-plugin
export default {"priorityLabel":"bxkW56tM4EKG8tcGgYP6","dotGrey":"VqkJh1wT0iegRi0mUsFR","dotBlue":"wsie8Z84JzdBG0zzQSQ2","dotYellow":"E0cbXjfE0sYHyK3pxeMC","dotRed":"cYwN48i5WEc4e6RWp2op"};